import React from "react";
import {
    Alert,
    Button,
    Card,
    Form,
    Input,
    message,
    Typography,
} from "antd";
import AdminUsersAPI from "../api/adminUsers";

const { Paragraph } = Typography;

export default function AdminReset2FA() {
    const [messageApi, contextHolder] = message.useMessage();
    const [form] = Form.useForm();

    const onReset = (values) => {
        AdminUsersAPI.reset2fa(
            values.username,
            (res) => {
                messageApi.success(
                    `Reset: ${res.totp_deleted} TOTP device(s), ${res.backup_deleted} backup code(s).`
                );
                form.resetFields();
            },
            (err) => {
                console.log(err);
                messageApi.error("Reset failed");
            },
        );
    };

    return <Card title="Admin — Reset 2FA">
        {contextHolder}
        <Alert
            type="warning"
            showIcon
            message="Verify identity out-of-band before resetting."
            description="This clears the user's TOTP device and all backup codes. Confirm the request in person with a physical ID card, or through another trusted channel."
            style={{ marginBottom: 16 }}
        />
        <Paragraph>
            Enter the username whose 2FA enrollment you want to clear. They will
            need to enroll again on next login.
        </Paragraph>
        <Form form={form} onFinish={onReset} layout="inline">
            <Form.Item name="username" rules={[{ required: true }]}>
                <Input placeholder="username" />
            </Form.Item>
            <Form.Item>
                <Button danger type="primary" htmlType="submit">Reset 2FA</Button>
            </Form.Item>
        </Form>
    </Card>;
}
